import React, { useState } from "react";
import { Button, Alert } from "../../../../../components";
import {
  FormTextInput,
  FormSelect,
  FormHiddenInput,
  useFormContext,
} from "../../../../../features/auto-form";
import { FormHiddenCalendar } from "../../../../../modules/custom-form-modules";
//import { useTranslate } from "../../../features/translation/hooks/use-translation";
import AO_FLEXIBILITY_OPTIONS from "../data/ao-flexibility-options.json";

const AccommodationOnlySearch = () => {
  const [disableCheckout, setDisableCheckout] = useState(true);
  const [earliestCheckoutDate, setEarliestCheckoutDate] = useState(null);

  const { resetRefValue } = useFormContext();

  const reset = () => {
    resetRefValue("product.hotelName");
    resetRefValue("product.dates.checkin");
    resetRefValue("product.dates.checkout");
    resetRefValue("product.dates.flexibility");

    setEarliestCheckoutDate(null);
    setDisableCheckout(true);
  };

  const handleCheckinChange = (e) => {
    const { value } = e.target;
    if (value) {
      const date = new Date(value);
      date.setDate(date.getDate() + 1);
      if (earliestCheckoutDate < date) {
        resetRefValue("product.dates.checkout");
      }
      setEarliestCheckoutDate(date);
      setDisableCheckout(false);
    } else {
      setDisableCheckout(true);
    }
  };

  return (
    <div className="container" style={{ padding: "0", margin: "0" }}>
      <FormHiddenInput name="request.product.type" value="accommodationOnly" />
      <div className="row">
        <div className="col col-12">
          <Alert type="info">
            <div
              className="text base"
              dangerouslySetInnerHTML={{
                __html:
                  "At the moment we have a limit capability of accommodation only bookings. We are working on expanding this service. ",
              }}
            />
          </Alert>
        </div>
      </div>
      {/*}
            <div className='row'>
                <div className='col col-12 col-sm-6 col-md-4'>
                    <FormHiddenDestinationSelector
                        name="product.destination"
                        market="se"
                        label="Choose destination"
                        icon="map"
                        placeholder="Choose destination"
                        options={PACKAGE_DESTINATIONS}
                    />
                </div>
                <div className="col col-12 col-md-1" style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                    <p className="text base">
                        or
                    </p>
                </div>
                <div className='col col-12 col-sm-6 col-md-4'>
                    <FormTextInput
                        name="product.dates"
                        label="Hotel name(s)"
                        trailingIcon="hotel"
                        placeholder="Hotel name"
                    />
                </div>
                <div className="col col-12 col-md-3" style={{display:"flex", alignItems:"flex-end"}}>
                    <FormCheckboxGroup 
                        label=""
                        options={[
                            {label:"I am open to options", value:"flexibleDestination"},
                        ]}
                    />    
                </div>
            </div>
            {*/}

      <div className="row">
        <div className="col col-12 col-sm-6 col-md-5">
          <FormTextInput
            name="product.hotelName"
            label="Destination and/or hotel name(s)"
            placeholder="Enter destination and/or hotel name(s)"
            message="Separate multiple destinations/hotels with comma"
            required
            disabled={true}
          />
        </div>
        <div className="col col-12 col-sm-6 col-md-2">
          <FormHiddenCalendar
            name="product.dates.checkin"
            label="Check in"
            icon="calendar-checkin"
            placeholder="Select dates"
            onChange={handleCheckinChange}
            disabled={true}
          />
        </div>
        <div className="col col-12 col-sm-6 col-md-2">
          <FormHiddenCalendar
            name="product.dates.checkout"
            label="Check out"
            icon="calendar-checkout"
            placeholder="Select dates"
            min={earliestCheckoutDate}
            disabled={true}
            required={disableCheckout ? false : true}
            //  disabled={disableCheckout}
          />
        </div>
        <div className="col col-12 col-sm-6 col-md-3">
          <FormSelect
            name="product.dates.flexibility"
            label="Departure flexibility"
            placeholder="Select flexibility"
            options={AO_FLEXIBILITY_OPTIONS}
            disabled={true}
            required
          />
        </div>
      </div>
      <div className="row">
        <div
          className="col col-12"
          style={{ display: "flex", justifyContent: "end" }}
        >
          <Button
            label={"Reset fields"}
            className="ghost medium"
            style={{ border: 0, textDecoration: "underline" }}
            onClick={reset}
          />
        </div>
      </div>
    </div>
  );
};

export default AccommodationOnlySearch;
